jQuery(function ($) {
    var $grid       = $('.blogs-grid-blogs-row');
    var $allItems   = $grid.children('.blogs-grid-item');
    var $footer     = $('.blogs-toolbar-footer');
    var $perSelect  = $('#blogs-per-page-select');
    var $resultText = $('.blogs-result-count'); // opcjonalnie

    if (!$grid.length || !$allItems.length || !$footer.length || !$perSelect.length) return;

    // --- helpers ---------------------------------------------------------------
    function headerOffset() {
        var base = 80; // dostosuj do wysokości sticky headera
        var $admin = $('#wpadminbar');
        if ($admin.length) base += $admin.outerHeight();
        return base;
    }

    // Znajdź najlepszy cel przewinięcia: wrapper sekcji grida lub sam grid
    function getScrollTarget() {
        var $wrapper = $('.wp-block-wbdm-blogs-grid'); // masz tę klasę w wrapper_attributes
        if ($wrapper.length) return $wrapper;
        if ($grid.length) return $grid;
        return $('body');
    }

    function smoothScrollTo($el) {
        var top = ($el && $el.length ? $el.offset().top : 0) - headerOffset();
        top = Math.max(0, top);
        if ('scrollBehavior' in document.documentElement.style) {
            window.scrollTo({ top: top, behavior: 'smooth' });
        } else {
            $('html, body').stop(true).animate({ scrollTop: top }, 400);
        }
    }

    // --- state -----------------------------------------------------------------
    var $filtered   = $allItems;                 // current working set
    var perPage     = parseInt($perSelect.val() || 12, 10);
    var currentPage = 1;

    // --- utils -----------------------------------------------------------------
    function getParam(name) {
        var m = new RegExp('[?&]' + name + '=([^&#]*)').exec(window.location.search);
        return m ? decodeURIComponent(m[1].replace(/\+/g, ' ')) : null;
    }

    function setParam(name, val) {
        var url = new URL(window.location.href);
        if (val) url.searchParams.set(name, val);
        else     url.searchParams.delete(name);
        history.replaceState(null, '', url.toString());
    }

    // --- pagination ------------------------------------------------------------
    function renderPagination($collection, perPage) {
        var total = $collection.length;
        var max   = Math.max(1, Math.ceil(total / perPage));
        var html  = '';
        for (var i = 1; i <= max; i++) {
            html += '<a href="#" class="page-number' + (i === currentPage ? ' current' : '') + '" data-page="' + i + '">' + i + '</a>';
        }
        $footer.find('.blogs-toolbar-footer-pagination').html(html);
    }

    function updateCount(total, perPage, page) {
        if (!$resultText.length) return;
        if (total === 0) { $resultText.text('Brak wpisów'); return; }
        var start = (page - 1) * perPage + 1;
        var end   = Math.min(total, start + perPage - 1);
        $resultText.text('Wyświetlanie ' + start + '–' + end + ' z ' + total + ' wpisów');
    }

    function showPage($collection, perPage, page) {
        var start = (page - 1) * perPage;
        var end   = start + perPage;
        $allItems.hide();
        $collection.slice(start, end).show();
        updateCount($collection.length, perPage, page);
    }

    function applyFilter(slug) {
        currentPage = 1;
        if (!slug) {
            $filtered = $allItems;
        } else {
            $filtered = $allItems.filter(function () {
                // czytaj surowy atrybut, nie .data()
                var cats = this.getAttribute('data-cats') || '';
                if (!cats) return false;
                // token exact match (spacja-separowane slugi)
                return cats.split(/\s+/).indexOf(slug) !== -1;
            });
        }
        renderPagination($filtered, perPage);
        showPage($filtered, perPage, currentPage);
    }

    function setActiveCategory($a) {
        var $list = $a.closest('.post-categories');
        $list.find('a').removeClass('is-active');
        $a.addClass('is-active');
    }

    // Init from URL (?cat=slug)
    var initialSlug = getParam('cat');
    applyFilter(initialSlug);

    // per-page change
    $perSelect.on('change', function () {
        perPage = parseInt(this.value, 10) || 12;
        currentPage = 1;
        renderPagination($filtered, perPage);
        showPage($filtered, perPage, currentPage);
        // opcjonalnie przewiń do grida po zmianie per-page:
        // smoothScrollTo(getScrollTarget());
    });

    // pagination click
    $footer.on('click', '.page-number', function (e) {
        e.preventDefault();
        currentPage = parseInt($(this).data('page'), 10) || 1;
        $footer.find('.page-number').removeClass('current');
        $(this).addClass('current');
        showPage($filtered, perPage, currentPage);
        // opcjonalnie przewiń do grida na zmianę strony:
        // smoothScrollTo(getScrollTarget());
    });

    // category click in HERO → filter + SCROLL TO GRID
    $(document).on('click', '.post-categories .js-blog-cat', function (e) {
        e.preventDefault();
        var slug = $(this).data('catSlug') || $(this).data('cat-slug') || '';
        setActiveCategory($(this));
        setParam('cat', slug || null);
        applyFilter(slug || null);

        // SCROLL DO BLOG GRIDA (sekcja wrapper albo sam grid)
        smoothScrollTo(getScrollTarget());
    });

    // initial pagination render (in case)
    renderPagination($filtered, perPage);
    showPage($filtered, perPage, currentPage);
});
